import * as React from 'react';

import { ProductGroupDateForm } from 'components/MultiProductDateForm/ProductGroupDateForm';

export const EmbeddedProductGroupCalendar = () => {
  return <ProductGroupDateForm />;
};
